/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const usePackageInstances = (invoiceId, queryParams) => {
  return useInfiniteQuery({
    queryKey: queryKeys.packages.byInvoice(invoiceId),
    queryFn: ({ pageParam }) => fetcher({
      method: "GET",
      url: "/public/packages/instances",
      params: { invoice_id: invoiceId, page: pageParam, on_page: 10 },
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.metadata?.page < lastPage.metadata?.pages_count
        ? lastPage.metadata.page + 1
        : undefined,
    ...queryParams,
  });
};

export const usePackages = (queryParams) => {
  return useQuery({
    queryKey: queryKeys.packages.all,
    queryFn: async () => {
      const response = await fetcher({
        method: "GET",
        url: "/public/packages",
        params: { include: "services,products,paid_attributes" },
      });
      return response.data;
    },
    ...queryParams,
  });
};